var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k3-demo"},[_vm._v(" demo ")])
}
var staticRenderFns = []

export { render, staticRenderFns }